<div class="min-h-screen bg-white">
  <div class="mx-auto max-w-screen-2xl px-6 pt-6 sm:px-10 lg:pt-8">
    <bcs-header></bcs-header>
    <div class="mt-6 flex items-start justify-between gap-8 lg:mt-8">
      <app-signup-stepper
        class="block w-full max-w-3xl"
        [loginState]="loginComplete"
        [venueState]="venueTypeComplete"
        [planState]="planComplete"
        [reviewState]="reviewVenueComplete"
      ></app-signup-stepper>
      <span
        *ngIf="userEmail"
        class="hidden shrink-0 text-xs font-semibold uppercase tracking-widest text-gray-500 md:block"
      >{{ userEmail }}</span>
    </div>
  </div>
  <main class="mx-auto max-w-screen-2xl px-6 pb-16 pt-8 sm:px-10">
    <router-outlet></router-outlet>
  </main>
</div>

<!-- Debug FAB (Floating Action Button) - Only in development -->
<button
  *ngIf="showDebugFab"
  type="button"
  (click)="toggleDebugPanel()"
  class="fixed bottom-4 right-4 z-40 flex items-center justify-center w-14 h-14 bg-red-600 text-white rounded-full shadow-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 transition-all"
  title="Debug Panel"
>
  <!-- Tools/Settings Icon -->
  <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
    <path stroke-linecap="round" stroke-linejoin="round" d="M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 011.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.56.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.893.149c-.425.07-.765.383-.93.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 01-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107-.397.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 01-.12-1.45l.527-.737c.25-.35.273-.806.108-1.204-.165-.397-.505-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.107-1.204l-.527-.738a1.125 1.125 0 01.12-1.45l.773-.773a1.125 1.125 0 011.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71-.505.78-.929l.15-.894z" />
    <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
</button>

<!-- Debug Panel Component -->
<app-debug-panel></app-debug-panel>
